import fetch from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { convertFiltersToV5Format } from '../../utils/filterFormatConversionToV5';
import store from '../store';
import { enqueueSnackbar } from './snackbar';

export const listMarketplaceLogs = (payload) => (dispatch) => {
  const { marketplaceLogs } = store.getState();

  dispatch({
    type: REDUX_ACTIONS.MARKETPLACE_LOGS_LIST_LOADING,
  });

  const body = {
    query: {
      startDate: payload?.startDate || marketplaceLogs?.startDate,
      endDate: payload?.endDate || marketplaceLogs?.endDate,
      searchValue: payload?.searchValue || marketplaceLogs?.searchValue,
      limit: 100,
      page: payload?.page || 1,
      filters: convertFiltersToV5Format(marketplaceLogs?.filters?.items) || [],
      linkOperator: marketplaceLogs?.filters?.logicOperator || '',
      sort: marketplaceLogs?.sort || null
    }
  };

  return fetch
    .post('audit/noAuth/mkt', body)
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.MARKETPLACE_LOGS_LIST_SUCCESS,
        payload: {
          marketplaceLogs: data.data,
          paginatedElements: data.data.count,
          totalCount: data.count
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);

      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.MARKETPLACE_LOGS_LIST_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};
